// These keys must match the form_key values set in the Form Numbers admin page
export const FORM_KEYS = {
  MATERIAL_REQUEST: "MATERIAL_REQUEST",
  QC_TRANSFER: "QC_TRANSFER",
  FINISHED_GOODS: "FINISHED_GOODS",
  QUOTATION: "QUOTATION",
};
